import Vue from 'vue'
import HeaderView from './components/HeaderView.vue'
import MobileNavigationView from './components/MobileNavigationView.vue'
import RegistrationErrorView from './components/RegistrationErrorView'
import PageMessagesView from '../../_layouts/components/PageMessagesView.vue'
import RegistrationTabs from "./components/RegistrationTabs";
import FontAwesomeIcon from "../../_layouts/components/FontAwesomeIcon";


// Page Areas
Vue.component('header-wrapper', HeaderView);
Vue.component('nav-mobile', MobileNavigationView);


// Components
Vue.component('registration-error', RegistrationErrorView);
Vue.component('page-messages', PageMessagesView);
Vue.component('registration-tabs', RegistrationTabs);
Vue.component('font-awesome-icon', FontAwesomeIcon);
